import gql from 'graphql-tag';
import { short as shortUser } from './user';

export const reaction = gql`
  fragment Reaction on Reaction {
    type
    user {
      ...ShortUser
    }
  }

  ${shortUser}
`;

export const attachment = gql`
  fragment ChatAttachment on Attachment {
    url
    fileKey
    name: originalFilename
    width
    height
    contentType
    thumbnails {
      medium {
        url
        width
      }
    }
  }
`;

export const token = gql`
  fragment ChatMetaToken on Token {
    type
    value
    href
    highlight
  }
`;

export const messageMeta = gql`
  fragment ChatMessageMeta on Meta {
    id
    uuid
    users {
      ...ShortUser
    }
    reactions {
      ...Reaction
    }
    channelName
    attachments {
      ...ChatAttachment
    }
    tokens {
      ...ChatMetaToken
    }
    cardId
    startDate
    endDate
  }

  ${shortUser}
  ${reaction}
  ${attachment}
  ${token}
`;

export const message = gql`
  fragment ChatMessage on Message {
    id
    # TODO(fant): move over to author (as wished by backend).
    # Note: this is time-consuming atm because this field is
    # used in the frontend, but it's untyped so hard to see where.
    sender: author {
      ...ShortUser
    }
    type
    subType
    content
    createdAt
    editedAt
    urgent: isImportant
    sentBySMS: fromSms
    meta {
      ...ChatMessageMeta
    }
  }

  ${shortUser}
  ${messageMeta}
`;

export const readMarker = gql`
  fragment ChatUserReadMarker on UserReadMarker {
    readAt
    user {
      ...ShortUser
    }
  }

  ${shortUser}
`;
